import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useRef, useState } from "react";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import MUIPopover from "@mui/material/Popover";
import MUIPopper from "@mui/material/Popper";
import classNames from "classnames";
import { CloseButton } from "../../components/CloseButton/CloseButton";
import { Icon } from "../../components/Icon/Icon";
import { defaultPopperContext, usePopper } from "../../components/PopperProvider/PopperProvider";
import { useViewport } from "../../hooks/useViewport";
import HelpIcon from "../../icons/help.svg";
import styles from "./PopoverButton.module.scss";
const MOBILE_WIDTH = 768;
export const PopoverButton = memo(({ content, popperClassName = "", helperClass = "", closeBtnClassName = "", opened, onOpen, onClose, anchorEl, anchorOrigin, transformOrigin, showCloseBtn = true, showHelpIcon = false, popperVariant = "default", icon = null, openedIcon = icon, closedIcon = icon, isPopper = false, ...buttonProps }) => {
    const btn = useRef(null);
    const [isOpened, setIsOpened] = useState(false);
    const { width } = useViewport();
    const isMobile = width < MOBILE_WIDTH;
    const { activePopperId, setActivePopperId } = usePopper();
    const isUsingProvider = activePopperId !== defaultPopperContext.activePopperId;
    const uniqueId = useRef(`popper-${Math.random().toString(36).substring(2, 11)}`).current;
    const handleOpenClick = (event) => {
        setActivePopperId(uniqueId);
        if (onOpen) {
            onOpen();
        }
        else {
            setIsOpened(true);
            event.stopPropagation();
        }
    };
    const close = () => {
        if (onClose) {
            onClose();
        }
        else {
            setIsOpened(false);
        }
    };
    const handleCloseClick = (event) => {
        close();
        event?.stopPropagation();
    };
    const handleClickAway = () => {
        close();
    };
    const handleCopy = (event) => {
        event.stopPropagation();
    };
    const anchor = anchorOrigin || {
        vertical: "bottom",
        horizontal: "right",
    };
    const transform = transformOrigin || {
        vertical: "top",
        horizontal: "right",
    };
    let isPopoverOpen = opened !== undefined ? !!opened : isOpened;
    if (isUsingProvider) {
        isPopoverOpen = isPopoverOpen && activePopperId === uniqueId;
    }
    const selectedIcon = isPopoverOpen ? openedIcon : closedIcon;
    const popperClasses = classNames(styles.popper, popperClassName, styles[`popper--${popperVariant}`]);
    const popperProps = {
        open: isPopoverOpen,
        anchorEl: anchorEl ?? btn.current,
        className: helperClass,
    };
    const popoverProps = {
        ...popperProps,
        onClose: handleCloseClick,
        anchorOrigin: anchor,
        transformOrigin: transform,
    };
    const renderContent = () => (_jsxs("div", { className: popperClasses, onClick: handleCopy, children: [showHelpIcon && _jsx(Icon, { className: styles.helpIcon, component: HelpIcon, width: "26px", height: "26px" }), content, showCloseBtn && _jsx(CloseButton, { onClick: handleCloseClick, className: `${styles.close} ${closeBtnClassName}` })] }));
    return (_jsxs(_Fragment, { children: [_jsx("button", { ref: btn, ...buttonProps, onClick: isPopoverOpen ? handleCloseClick : handleOpenClick, type: "button", onDoubleClick: isPopoverOpen ? handleOpenClick : handleCloseClick, children: selectedIcon }), isPopper ? (_jsx(ClickAwayListener, { onClickAway: handleClickAway, children: _jsx(MUIPopper, { ...popperProps, placement: !isMobile ? "auto" : "bottom-end", children: renderContent() }) })) : (_jsx(MUIPopover, { ...popoverProps, children: renderContent() }))] }));
});
//# sourceMappingURL=PopoverButton.js.map